module.exports = __webpack_public_path__ + "static/img/logo_game.497bc21.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_game.jpg
// module id = HM/M
// module chunks = 1